import React, { Component } from "react";
import Lightbox from "react-lightbox-gallery";
import PageFooter from "../../components/PageFooter";
import pattern from "../../assets/pattern.jpg";

import galleryImg1 from "../../assets/gallery/birthday/birthday01.jpg";
import galleryImg2 from "../../assets/gallery/birthday/birthday02.jpg";
import galleryImg3 from "../../assets/gallery/birthday/birthday03.jpg";
import galleryImg4 from "../../assets/gallery/birthday/birthday04.jpg";
import galleryImg5 from "../../assets/gallery/birthday/birthday05.jpg";
import galleryImg6 from "../../assets/gallery/birthday/birthday06.jpg";
import galleryImg7 from "../../assets/gallery/birthday/birthday07.jpg";
import galleryImg8 from "../../assets/gallery/birthday/birthday08.jpg";
import galleryImg9 from "../../assets/gallery/birthday/birthday09.jpg";
import galleryImg10 from "../../assets/gallery/birthday/birthday10.jpg";
import galleryImg11 from "../../assets/gallery/birthday/birthday11.jpg";
import galleryImg12 from "../../assets/gallery/birthday/birthday12.jpg";
import { NavLink } from "react-router-dom";

export default class Gallery1 extends Component {
  render() {
    var images = [
      {
        src: galleryImg1,
      },
      {
        src: galleryImg2,
      },
      {
        src: galleryImg3,
      },
      {
        src: galleryImg4,
      },
      {
        src: galleryImg5,
      },
      {
        src: galleryImg6,
      },
      {
        src: galleryImg7,
      },
      {
        src: galleryImg8,
      },
      {
        src: galleryImg9,
      },
      {
        src: galleryImg10,
      },
      {
        src: galleryImg11,
      },
      {
        src: galleryImg12,
      },
    ];
    var settings = {
      columnCount: {
        default: 3,
        mobile: 3,
        tab: 4,
      },
      mode: "dark",
    };
    return (
      <>
        <div
          className="w-full h-[75px] mb-10 bg-repeat bg-contain"
          style={{ backgroundImage: "url(" + pattern + ")" }}
        ></div>
        <div className="container mx-auto px-4">
          <div className="md:p-8 mb-10 pb-10 bg-cream rounded-md shadow-md">
            <h1 className="text-center pt-16 md:p-0 mb-10">Birthday Cookies</h1>
            <Lightbox
              images={images}
              settings={settings}
              className="lb-helper"
            />
            <NavLink
              to="/gallery"
              className="w-fit mx-auto bg-brand hover:bg-brandlt text-cream hover:text-brand border-2 border-brand hover:border-brandlt font-bold py-2 px-4 rounded-full transition-all shadow-md block"
            >
              Back to Galleries
            </NavLink>
          </div>
        </div>

        <PageFooter />
      </>
    );
  }
}
